import * as React from 'react'

import {noop} from '../../../../../../utils/empty'

import type {CleanupFormAction} from './CleanupForm.types'

export const LoadingContext = React.createContext<boolean>(true)
export const DispatchContext = React.createContext<(action: CleanupFormAction) => void>(noop)
